import { render, staticRenderFns } from "./documentExcelToWord.vue?vue&type=template&id=113b2295&"
import script from "./documentExcelToWord.vue?vue&type=script&lang=js&"
export * from "./documentExcelToWord.vue?vue&type=script&lang=js&"
import style0 from "./documentExcelToWord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports